import Filters from '@nematis/hooks/lib/filters'

export default class AppManager {
  static getVendor() {
    return 'nematis'
  }

  static getType() {
    return null
  }

  static getConfig() {
    return {
      attrNames: {
        name: 'data-app-name',
        id: 'id',
        targetName: 'data-target-app-name',
        targetId: 'data-target-id'
      }
    }
  }

  static getInstance() {
    return this._manager
  }

  static getInstanceName() {
    return `_${this.getVendor()}AppManager`
  }

  static getApps() {
    return this._manager.apps
  }

  static getAppInfo(appName, id) {
    const store = this._getStore(appName)
    if (store && store.length) {
      if (id) {
        return store.find((v) => v.el.id === id)
      }

      return store[0]
    }

    return null
  }

  static getAppInfoByElement(el) {
    if (!this._isValidElement(el)) {
      return null
    }

    const appName = this.getAppAttribute(el, 'name')
    const id = this.getAppAttribute(el, 'id')

    return this.getAppInfo(appName, id)
  }

  static getAppAttribute(el, name) {
    const config = this.getConfig()
    if (name in config.attrNames) {
      return el.getAttribute(config.attrNames[name])
    }

    return null
  }

  static async loadAppFromElement(el, data = {}, filters = null) {
    if (!this._isValidElement(el)) {
      return false
    }

    const appType = this.getType()
    const appName = this.getAppAttribute(el, 'name')
    const id = this.getAppAttribute(el, 'id')

    if (this.getAppInfoByElement(el)) {
      return false
    }

    filters = this._sanitizeFilters(filters)

    // allow other components to trigger actions before app load
    await filters.doActionAsync(`app.${appType}.beforeLoad`, appName, id, el, data)

    // allow other components to filter app data before load
    data = filters.applyFilters(`app.${appType}.data`, data, appName, id, el)

    // effectively build app
    const app = await this._buildApp(appName, id, el, data, filters)
    this._registerApp(app, appName, el, filters)

    // inform other components that this app has been loaded
    filters.doAction(`app.${appType}.loaded`, app, appName, id, el)

    return this.getAppInfoByElement(el)
  }

  /* INTERNAL METHODS */

  static _register() {
    if (!this._manager) {
      this._manager = {
        apps: new Map()
      }
    }
  }

  static get _manager() {
    const instanceName = this.getInstanceName()
    if (!(instanceName in window)) {
      return null
    }

    return window[instanceName]
  }

  static set _manager(instance) {
    const instanceName = this.getInstanceName()
    if (!this._manager) {
      window[instanceName] = instance
    }
  }

  static _isValidElement(el) {
    return el && this.getAppAttribute(el, 'name') !== null
  }

  // eslint-disable-next-line require-await
  static async _buildApp(appName, id, el, data, filters) {
    return null
  }

  static _registerApp(app, appName, el, filters) {
    const store = this._getStore(appName, true)
    if (this._storeHasElement(store, el)) {
      throw new Error('Element already registered.')
    }

    const namespace = filters.namespace('app')

    store.push({
      app,
      el,
      namespace
    })
  }

  static _getStore(appName, init = false) {
    const appType = this.getType()
    if (!this._manager.apps.has(appType)) {
      this._manager.apps.set(appType, new Map())
    }

    const store = this._manager.apps.get(appType)
    if (appName && !store.has(appName) && init) {
      store.set(appName, [])
    }

    return appName ? store.get(appName) : store
  }

  static _storeHasElement(store, el) {
    return store && store.find((v) => v.el === el)
  }

  static _sanitizeFilters(filters) {
    // ensure we have filters, otherwise get default filters
    if (!filters) {
      filters = Filters
    }

    return filters
  }
}
